import React, { useEffect, memo, useRef } from 'react';
import { CircleMarker, useMap } from 'react-leaflet';

import { ILocation } from '../../api/types';
import { useMapTargetToUser } from './useMapTargetToUser';

interface UserLocationProps {
    location: ILocation;
}

const pathOptions = {
    color: '#004FC6',
    opacity: 0.5,
    stroke: true,
    fillColor: '#004FC6',
    fillOpacity: 1,
    weight: 4,
};

function UserLocation(props: UserLocationProps) {
    const { location } = props;
    const { targetToUser } = useMapTargetToUser();
    const map = useMap();
    const hasInitiallyCentered = useRef(false);

    useEffect(() => {
        if (!hasInitiallyCentered.current && location.lat && location.lng) {
            targetToUser();
            hasInitiallyCentered.current = true;
        }
    }, [location, map]);

    if (!location?.lat && !location?.lng) {
        return null;
    }

    return (
        <CircleMarker
            eventHandlers={{ click: targetToUser }}
            center={[location.lat, location.lng]}
            radius={8}
            pathOptions={pathOptions}
        />
    );
}

export default memo(UserLocation);
